// src/OfficeSpaceCard.js

import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom'; // Import the Link component for navigation
import { useTranslation } from 'react-i18next';

const Card = styled(Link)`
  width: 300px;
  margin: 10px;
  padding: 20px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  text-decoration: none; /* Remove default link styles */
  color: inherit; /* Inherit text color */
  display: block; /* Make the whole card clickable */

  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    transition: box-shadow 0.3s ease;
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  height: 200px;
  overflow: hidden;
  border-radius: 10px;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Title = styled.h2`
  font-size: 1.5rem;
  margin: 10px 0;
`;

const Location = styled.p`
  font-size: 1rem;
  color: #666;
`;

const Price = styled.p`
  font-size: 1.25rem;
  color: #007bff;
  margin: 10px 0;
`;

const OfficeSpaceCard = ({ space, lng }) => {
  const { t } = useTranslation();

  // List of words to translate
  const keywords = [
    "Cozy", "Modern", "Spacious", "Luxurious", "Affordable",
    "Office", "Workspace", "Conference Room", "Desk"
  ];

  // Translate space.name dynamically
  const translatedName = space.name
    .split(" ")
    .map(word => keywords.includes(word) ? t(word.toLowerCase().replace(" ", "_")) : word)
    .join(" ");

  // Split the images string into an array
  const imageArray = space.images ? space.images.split(',') : [];

  return (
    <Card to={`/listing/${space.id}`}>
      <ImageContainer>
        {imageArray.length > 0 ? (
          <Image src={imageArray[0]} alt={translatedName} />
        ) : (
          <Image src="/placeholder.jpg" alt="No image available" />
        )}
      </ImageContainer>
      <Title>{translatedName}</Title>
      <Location>{space.city + ', ' + space.country}</Location>
      <Price>€{space.price} / {t('hour')}</Price>
    </Card>
  );
};

export default OfficeSpaceCard;
